import React from "react";
import "./Your_Idea.css";
import Purple_Btn from "../common_btn/purple_btn/Purple_Btn";
import { useNavigate } from "react-router-dom";

function Your_Idea({ btnText, title, description }) {
  const navigate = useNavigate();
  return (
    <>
      <section className="Your_Idea">
        <div className="custom_container">
          <div className="row align-items-end">
            <div className="col-md-8">
              <div className="text_holder">
                <h1>
                  <span>Product Care </span> Made Simple
                </h1>
                <p>
                  Keep your products looking their best with easy care and
                  maintenance tips. From cleaning and storage to handling and
                  protection, we guide you every step of the way to ensure
                  long-lasting quality and performance.
                </p>
              </div>
            </div>

            <div className="col-md-4">
              {/* <div className="btn_holder">
                <Purple_Btn
                  btnText={btnText}
                  onClick={() => navigate("/luxury/bespock-gift")}
                />
              </div> */}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Your_Idea;
